const EyeClosedIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none">
      <path
        d="M7.96582 3.75531L8.26471 6.03844"
        stroke="#BDC2C5"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.81055 3.19092L10.9065 5.22612"
        stroke="#BDC2C5"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4976 2.01257L13.0002 3.75535"
        stroke="#BDC2C5"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.03424 3.75531L5.73535 6.03844"
        stroke="#BDC2C5"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.18968 3.19092L3.09375 5.22612"
        stroke="#BDC2C5"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5026 2.01257L1 3.75535"
        stroke="#BDC2C5"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 1.25C13 1.25 11.1405 4.77788 7 4.77788C2.85952 4.77788 1 1.25 1 1.25"
        stroke="#BDC2C5"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EyeClosedIcon;
